import { render, staticRenderFns } from "./OpportunityKanbanFilters.vue?vue&type=template&id=19d11448&scoped=true&"
import script from "./OpportunityKanbanFilters.vue?vue&type=script&lang=js&"
export * from "./OpportunityKanbanFilters.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityKanbanFilters.vue?vue&type=style&index=0&id=19d11448&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d11448",
  null
  
)

export default component.exports